<div class="collapsible-row" [class.no-border]="isLastRow">
  <div class="collapsible-row-header" [class.has-value]="isRowHasValue">
    <div class="collapsible-row-icon">
      @if (isRowHasValue && !isRowExpanded) {
        <div class="icon-success"><rkt-icon name="check"></rkt-icon></div>
      }
      @if (number && (!isRowHasValue || isRowExpanded)) {
        <div class="default" [class.is-expanded]="isRowExpanded">{{ number }}</div>
      }
      @if (iconName && (!isRowHasValue || isRowExpanded)) {
        <div class="default-icon" [class.is-expanded]="isRowExpanded">
          <rkt-icon [name]="iconName"></rkt-icon>
        </div>
      }
    </div>
    <div class="collapsible-row-label">
      {{ label }}
    </div>
  </div>

  <div class="collapsible-row-content">
    <ng-content></ng-content>
  </div>
</div>
